import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const RegulatoryDisclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-400/20 blur-3xl rounded-full"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 py-10">

        {/* HEADER */}
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold">
            Regulatory Disclaimer
          </h1>
          <p className="text-white/80 mt-2">
            AICA HEALTH — Compliance & Regulatory Notice
          </p>
        </div>

        {/* CONTENT CARD */}
        <div className="bg-white/10 border border-white/20 rounded-2xl p-6 sm:p-8 backdrop-blur-xl shadow-lg space-y-6">

          <p className="text-white/80 whitespace-pre-line leading-relaxed">

AICA HEALTH

Certain Platform features, systems, models, outputs, or workflows may:

● remain investigational,
● be pilot-stage,
● undergo validation,
● be calibration-dependent,
● evolve over time.

Unless expressly stated otherwise:

● the Platform may not constitute a regulated medical device;
● the Platform may not possess regulatory approvals in all jurisdictions;
● outputs may not be clinically validated across all populations or conditions.

Nothing on the Platform shall be interpreted as:

● FDA approval,
● CDSCO approval,
● diagnostic certification,
● medical certification,
● guaranteed clinical efficacy,

unless expressly stated in writing by AICA.

The Platform is intended as an assistive preventive and proactive healthcare support system
and not as an autonomous clinical decision-making system.

          </p>

        </div>

        {/* FOOTER */}
        <div className="mt-12 flex items-center justify-between border-t border-white/20 pt-6">

          <p className="text-white/70 text-sm">
            © {new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd
          </p>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 bg-white text-teal-700 font-semibold rounded-xl shadow hover:bg-gray-200 transition"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      </div>
    </div>
  );
};

export default RegulatoryDisclaimer;